import React from 'react';
import styled from 'styled-components'
import MailchimpSubscribe from 'react-mailchimp-subscribe';
import Page from './../containers/Page';
import Seo from './../components/Seo';
import { GhostButton } from './../components';

const Layout = styled.section`
  color: #fff;
  display: grid;
  min-height: 100vh;
  padding: 50px 36px;
  background-color: #041E42;

  @media screen and (min-width: 992px) {
    padding: 50px 0;
  }
`;

const Container = styled.div`
  display: grid;
  grid-area: 1/1;
  position: relative;
  place-items: center;
`;

const PageTitle = styled.h1`
  font-size: 1.625rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 50px;

  @media screen and (min-width: 768px) {
    font-size: 2.25rem;
  }
`;

const InputWrapper = styled.div`
  margin-bottom: 26px;
  font-size: 1.1875rem;
  font-family: 'Sica', sans-serif;
`;

const InputLabel = styled.label`
  display: block;
  margin-bottom: 6px;
`;

const InputField = styled.input`
  font-family: 'Sica', sans-serif;
  font-size: 1.1875rem;
  padding: 8px 12px;
  width: 250px;
  background-color: transparent;
  color: #fff;
  border: none;
  border-bottom: 2px solid #fff;
  transition: background-color .1s linear;

  &:focus {
    outline: none;
    background-color: rgba(255, 255, 255, .05); 
  }

  @media screen and (min-width: 992px) {
    width: 360px;
  }
`;

const SubmitWrapper = styled.div`
  text-align: center;
`;

const SubmitButton = styled.button`
  background-color: transparent;
  border: none;

  &:focus {
    outline: none;
  }
`;

const MessageWrapper = styled.div`
  text-align: center;
  font-size: 1.1875rem;
`;

const DisclaimerText = styled.p`
  max-width: 360px;
  margin: 1rem 1rem 0;
  font-family: 'Sica', sans-serif;
  font-size: 0.875rem;
  font-style: italic;

  @media screen and (min-width: 992px) {
    margin: 1rem auto 0;
  }
`

const CustomForm = ({ status, message, onValidated }) => {
  let email, fname, lname, mmerge3, mmerge4;
  const submit = () =>
    email &&
    fname &&
    lname &&
    mmerge3 &&
    mmerge4 &&
    email.value.indexOf("@") > -1 &&
    onValidated({
      EMAIL: email.value,
      FNAME: fname.value,
      LNAME: lname.value,
      MMERGE3: mmerge3.value,
      MMERGE4: mmerge4.value,
    });

  return (
    <div>
      <InputWrapper>
        <InputLabel>
          First name
        </InputLabel>
        <InputField
          ref={node => (fname = node)}
          type="text"
          required
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel>
          Last name
        </InputLabel>
        <InputField
          ref={node => (lname = node)}
          type="text"
          required
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel>
          Number of attendees
        </InputLabel>
        <InputField
          ref={node => (mmerge3 = node)}
          type="number"
          required
        />
      </InputWrapper>
      <InputWrapper> 
        <InputLabel>
          Company name
        </InputLabel>
        <InputField
          ref={node => (mmerge4 = node)}
          type="text"
          required
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel>
          Email address
        </InputLabel>
        <InputField
          ref={node => (email = node)}
          type="email"
          required
        />
      </InputWrapper>
      <br />
      {status === 'success' ? null : (
        <SubmitWrapper>
          <SubmitButton onClick={submit} disabled={status === 'sending'}>
            <GhostButton>
              Send
            </GhostButton>
          </SubmitButton>
        </SubmitWrapper>
      )}
      {status === 'sending' && (
        <MessageWrapper>
          <p><i>Sending.</i></p>
        </MessageWrapper>
      )}
      {status === 'error' && (
        <MessageWrapper dangerouslySetInnerHTML={{ __html: message }} />
      )}
      {status === 'success' && (
        <MessageWrapper dangerouslySetInnerHTML={{ __html: message }} />
      )}
    </div>
  );
};

const SignupPage = () => {
  return (
    <Page isIndex={true}>
      <Seo title="Sign up" />
      <Layout>
        <Container>
          <div>
            <PageTitle>
              Sign up here
            </PageTitle>
            <MailchimpSubscribe
              url="https://agency.us1.list-manage.com/subscribe/post?u=620ca070426b2e343d2d3c35a&id=fbe8062ac8"
              render={({ subscribe, status, message }) => (
                <CustomForm
                  status={status}
                  message={message}
                  onValidated={formData => subscribe(formData)}
                />
              )}
            />
            <DisclaimerText>
              After signing up for the event, Green Gate Incoming will contact you and assist you booking flights, hotel, car, trips etc.<br /><br />
              Please note that your flights, hotel, food, local tours and other activities Saturday evening is at your expense. Petur Larsen is host for all other activities the 19th-21st of May.
            </DisclaimerText>
          </div>
        </Container>
      </Layout>
    </Page>
  );
}

export default SignupPage;